export const phaseOptionsArray = [
  { value: 'Single Phase', label: 'Single Phase' },
  { value: 'Three Phase', label: 'Three Phase' }
]


// WEBPACK FOOTER //
// ./src/utils/phaseOptionsArray.js